import { render, staticRenderFns } from "./CloseOrActivateDialog.vue?vue&type=template&id=9d4e6e1a&scoped=true"
import script from "./CloseOrActivateDialog.vue?vue&type=script&lang=js"
export * from "./CloseOrActivateDialog.vue?vue&type=script&lang=js"
import style0 from "./CloseOrActivateDialog.vue?vue&type=style&index=0&id=9d4e6e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e6e1a",
  null
  
)

export default component.exports